export const toCurrency = (amount, currencyCode) => {
  // Handle percentage values
  if (typeof amount === "string" && amount.endsWith("%")) {
    return amount;
  }

  if (typeof amount !== "number") {
    amount = parseFloat(amount);
  }

  const locale =
    navigator.languages !== undefined
      ? navigator.languages[0]
      : navigator.language;

  // Determine if amount is a whole number or has fractions
  const isWholeNumber = amount % 1 === 0;

  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: isWholeNumber ? 0 : 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(amount);
};

export const pluralize = (word, amount) => {
  return amount > 1 || amount == 0 ? `${word}s` : word;
};
